import { useScreenWidth } from "@msys/ui";
import { Stack } from "@mui/material";
import { useFormikContext } from "formik";
import moment from "moment";
import { DatePickerField } from "./DatePickerField.js";
import { TimePickerField } from "./TimePickerField.js";

export function DateAndTimePickersField({
  name,
  dateLabel,
  timeLabel,
  disabled,
  required,
}: {
  name: string;
  dateLabel: string;
  timeLabel: string;
  disabled?: boolean;
  required?: boolean;
}) {
  const { isMaxPhone } = useScreenWidth();
  const { values, setFieldValue, setFieldTouched } =
    useFormikContext<Record<string, any>>();

  return (
    <Stack
      spacing={1}
      direction={isMaxPhone ? "column" : "row"}
      sx={{
        width: "100%",
      }}
    >
      <DatePickerField
        label={dateLabel}
        name={name}
        value={values.time}
        onChange={async (event, value) => {
          await setFieldValue(
            name,
            moment(value).set({
              hours: values.time?.hours(),
              minutes: values.time?.minutes(),
            })
          );
        }}
        disabled={disabled}
        required={required}
      />
      <TimePickerField
        label={timeLabel}
        name={name}
        value={values.time ? moment(values.time).format("HH:mm") : ""}
        onChange={async (event, value) => {
          const [hours, minutes] = value
            ?.split(":")
            .map(element => parseInt(element)) ?? [0, 0];
          await setFieldValue(
            name,
            moment(values.time).set({ hours, minutes })
          );
        }}
        disabled={disabled || !values.time}
        required={required}
      />
    </Stack>
  );
}
